import { createI18n } from "vue-i18n";
import { components } from "./internacionalization/components";
import { pages } from "./internacionalization/pages";

export type Translation = Record<string, string>;
export type Internationalization = Record<string, Record<string, Translation>>;

const componentsI18n = {
  pt: components.pt,
  en: components.en,
}

const pagesI18n = {
  pt: pages.pt,
  en: pages.en,
}

const messages = {
  pt: {
    component: componentsI18n.pt,
    ...pagesI18n.pt,
  },
  en: {
    component: componentsI18n.en,
    ...pagesI18n.en,
  },
}

const i18n = createI18n({
  legacy: false,
  locale: "pt",
  fallbackLocale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
